import { render, staticRenderFns } from "./modifiyFreightDialog.vue?vue&type=template&id=6f0aa794"
import script from "./modifiyFreightDialog.vue?vue&type=script&lang=js"
export * from "./modifiyFreightDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports